export default __webpack_public_path__ + "static/media/flight-service-background.d4e7b213.jpg";